module.exports = __webpack_public_path__ + "img/ring_y_l_0_0@2x.06d2a663.png";